import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

//  =========   ADDRESS  ==========
type AddressProps = {
  id: ?string,
  clientId: ?string,

  isDeleted: ?boolean,

  createdAt: ?string,
  modifiedAt: ?string,
  userModifiedAt: ?string,

  fullName: ?string,
  line1: ?string,
  line2: ?string,
  city: ?string,
  state: ?string,
  country: ?string,
  zipCode: ?string,
  defaultForBilling: ?boolean,
  defaultForShipping: ?boolean,
  primary: ?boolean,
  authUse: ?boolean,
  verified: ?boolean,
  userProfileId: ?string,

};
export type Address = RecordOf<AddressProps>;

export const makeAddress: RecordFactory<AddressProps> =
  Record({
    id: null,
    clientId: undefined,

    isDeleted: undefined,

    createdAt: undefined,
    modifiedAt: undefined,
    userModifiedAt: undefined,

    fullName: '',
    line1: undefined,
    line2: undefined,
    city: undefined,
    state: undefined,
    country: undefined,
    zipCode: undefined,
    defaultForBilling: undefined,
    defaultForShipping: undefined,
    primary: undefined,
    authUse: undefined,
    verified: undefined,
    userProfileId: undefined,
  });

//  =========   PHONE  ==========
type PhoneProps = {
  authUse: ?boolean,
  createdAt: ?string,
  id: ?string,
  modifiedAt: ?string,
  number: ?string,
  primary: ?boolean,
  type: ?string,
  verified: ?boolean,
};
export type Phone = RecordOf<PhoneProps>;
export const makePhone: RecordFactory<PhoneProps> =
  Record({
    authUse: undefined,
    createdAt: undefined,
    id: undefined,
    modifiedAt: undefined,
    number: undefined,
    primary: undefined,
    type: undefined,
    verified: undefined,
  });


//  =========   EMAIL  ==========
type EmailProps = {
  address: ?string,
  authUse: ?boolean,
  createdAt: ?string,
  emailCommSourceType: ?string,
  emailCommType: ?string,
  id: ?string,
  modifiedAt: ?string,
  primary: ?boolean,
  verified: ?boolean,
};
export type Email = RecordOf<EmailProps>;
export const makeEmail: RecordFactory<EmailProps> =
  Record({
    address: undefined,
    authUse: undefined,
    createdAt: undefined,
    emailCommSourceType: undefined,
    emailCommType: undefined,
    id: undefined,
    modifiedAt: undefined,
    primary: undefined,
    verified: undefined,
  });

//  =========   Profile  ==========
type ProfileProps = {
  id: ?string,
  clientId: ?string,

  isDeleted: ?boolean,

  createdAt: ?string,
  modifiedAt: ?string,
  userModifiedAt: ?string,

  userId: ?string,
  username: ?string,
  firstName: ?string,
  lastName: ?string,
  companyName: ?string,

  primaryAddress: Address,
  primaryPhone: Phone,
  primaryEmail: Email,
};
export type Profile = RecordOf<ProfileProps>;

export const makeProfile: RecordFactory<ProfileProps> =
  Record({
    id: undefined,
    clientId: undefined,

    isDeleted: undefined,

    createdAt: undefined,
    modifiedAt: undefined,
    userModifiedAt: undefined,

    userId: undefined,
    username: undefined,
    firstName: undefined,
    lastName: undefined,
    companyName: undefined,

    primaryAddress: undefined,
    primaryPhone: undefined,
    primaryEmail: undefined,
  });

export const makeProfileWithAddress = (jsObj: Object): Profile => makeProfile({
  ...jsObj,
  primaryAddress: jsObj.primaryAddress && makeAddress(jsObj.primaryAddress),
});

// Our store is generated by mkQcsSyncResourceStore in the reducer - it uses the default resourcesById format,
// even though we have only a single profile. This lets us leverage the same functionality and whatever future changes
// we make to our default redux format.
// -------
// export const ProfileStore = new Record({
// });

export const makeProfileFull = (jsObj: Object): Profile => makeProfile({
  ...jsObj,
  primaryAddress: jsObj.primaryAddress && makeAddress(jsObj.primaryAddress),
  primaryPhone: jsObj.primaryPhone && makePhone(jsObj.primaryPhone),
  primaryEmail: jsObj.primaryEmail && makeEmail(jsObj.primaryEmail),
});
